<template>
    <v-form v-model="valid" @submit.prevent="submit" ref="form">
        <p class="title mt-8">
            Ganti password
        </p>

        <v-text-field
            v-model="oldPassword"
            ref="oldPassword"
            label="Password lama"
            type="password"
            :rules="rules.password"
        ></v-text-field>

        <v-text-field
            v-model="password"
            label="Password baru"
            type="password"
            :rules="rules.password"
        ></v-text-field>

        <v-text-field
            v-model="passwordConfirmation"
            label="Ulangi password baru"
            type="password"
            :rules="rules.passwordConfirmation"
        ></v-text-field>

        <v-btn
            type="submit"
            large
            :disabled="!valid"
            :loading="$store.get('loader/loading', 'passwordchange')"
            color="primary"
            >
            Ganti
        </v-btn>
    </v-form>
</template>

<script>
export default {
    data() {
        return {
            rules: {
                password: [
                    v => !!v || 'Password harus diisi'
                ],

                passwordConfirmation: [
                    v => !!v || 'Konfirmasi password harus diisi',
                    v => v == this.password || 'Password tidak sama'
                ]
            },
            valid: null,
            oldPassword: null,
            password: null,
            passwordConfirmation: null,
        }
    },

    methods: {
        submit() {
            this.$api.put('auth/password', {
                old_password: this.oldPassword,
                new_password: this.password,
            }, { loader: 'passwordchange', noErrorRedirection: true })
                .then(response => {
                    if (response.data.updated) {
                        this.$refs.form.reset()

                        this.$store.dispatch('flash/info', 'Password telah diubah')
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$nextTick(this.$refs.oldPassword.focus)

                        this.$store.dispatch('flash/error', 'Password lama yang dimasukkan salah')
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
        }
    }
}
</script>
